import type { Dictionary } from '@types'

export const BENEFITS_CAPTIONS = {
  HEALTH_INSURANCE: 'Health Insurance',
  RETIREMENT_PLAN: 'Retirement Plan',
  PAID_TIME_OFF: 'Paid Time Off',
  LIFE_INSURANCE: 'Life Insurance',
  DISABILITY_INSURANCE: 'Disability Insurance',
  TUITION_REIMBURSEMENT: 'Tuition Reimbursement',
  EMPLOYEE_ASSISTANCE: 'Employee Assistance',
  FLEXIBLE_SPENDING_ACCOUNT: 'Flexible Spending Account',
  EMPLOYEE_DISCOUNTS: 'Employee Discounts',
  WELLNESS_PROGRAM: 'Wellness Program',
  SIGN_ON_BONUS: 'Sign On Bonus',
}

// Shorter than the page's `revalidate = 3600` on purpose, for two reasons. The working set scales
// with this window: ~70 MB here against ~800 MB at 3600s, on a Valkey shared with the ISR page
// cache. And the two caches compose — an entry this old can be the data a fresh ISR render is
// built from — so worst-case staleness is 3600s plus this TTL: 3900s at 300s, and it would have
// been 7200s at 3600s. The fan-out fix is the request memo, not this TTL [S20-770].
export const JOB_PAGE_CACHE_TTL_SECONDS = 300

export const basePath =
  process.env.NEXT_PUBLIC_BASE_PATH === '/' || process.env.NEXT_PUBLIC_BASE_PATH === null
    ? ''
    : (process.env.NEXT_PUBLIC_BASE_PATH as string).replace(/\/+$/, '')

export const dictionaries: Record<'us', Dictionary> = {
  us: {
    currency: '$',
    resume: 'resume',
    calendlyLink: 'https://calendly.com/hello-6515/sonicjobs-candidate-feedback-uk-30-minute-meeti-clone',
    jobs: '1M',
    exampleLocation: 'new york',
    country: 'United States',
    countryCodeISO: 'us',
    phonePrefix: '+1',
    zipCode: 'ZIP code',
  },
}
